import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { connect } from 'react-redux';

import { modalStyle, mediumModalStyle } from '../../constants';
import ClientAgencyInfoForm from './ClientAgencyInfoForm';
import { withAuth } from '../../actions/';
import { fetchClientAgencies } from '../../actions/additional_actions';
import { MdEdit, MdDelete, MdAccountBalance } from 'react-icons/lib/md';

class ClientAgencyInfo extends Component {
    // static PropTypes = {
    //     permissions: PropTypes.object.isRequired,
    //     projectId: PropTypes.string.isRequired,
    //     clientAgencies: PropTypes.array.isRequired,
    //     fetchClientAgencies: PropTypes.func.isRequired,
    // }
    constructor(props) {
        super(props);

        this.state = {
            toDelete: null,
            toEdit: null,
        }
        this.closeModal = this.closeModal.bind(this);
        this.onDone = this.onDone.bind(this);
        this.saveHandler = this.saveHandler.bind(this);
        this.deleteHandler = this.deleteHandler.bind(this);
        this.removeAgency = this.removeAgency.bind(this);
    }

    UNSAFE_componentWillMount() {
        this.props.fetchClientAgencies(this.props.projectId);
      }

      closeModal() {
        this.setState({
          toDelete: null,
          toEdit: null,
        });
      }

    startAdd(toEdit) {
        this.setState({ toEdit })
    }

    startEdit(obj) {
        this.setState({ toEdit: obj })
    }

    removeAgency (obj) {
       this.setState({ toDelete: obj });
    }
    
    deleteHandler () {
      const { projectId } = this.props;
      const Id = this.state.toDelete.id  
      const url = `/projects/${projectId}/clientAgencies/${Id}`;
      withAuth(
        {method: 'delete', url},
        () => {
          this.props.fetchClientAgencies(projectId);
          this.closeModal()
        },
        this.errorHandler
      );
    }

    onDone(shouldFetch) {
        // if (shouldFetch) this.loadInitial();
        this.setState({ toEdit: null });
    }

    saveHandler(clientAgency) {
        const { projectId } = this.props;
    
        let method = 'post';
        let url = `projects/${projectId}/clientAgencies`;

        if (clientAgency.id) {
          method = 'put';
          url = `${url}/${clientAgency.id}`;
        }
    
        return this.makePutOrPostRequest(clientAgency, method, url);
      }

      makePutOrPostRequest(clientAgency, method, url) {

        const { projectId } = this.props;
        clientAgency.projectId = projectId;
        
         withAuth(
           { method, url, data: clientAgency },
           () => {
             this.props.fetchClientAgencies(projectId);
             this.closeModal();
           },
       this.errorHandler
         )
      }

    renderRowButtons(agency) {
      return (
        <td>
          <button onClick={() => this.startEdit(agency)}>
            <span><MdEdit size={20} color='#8492a6' /></span>
          </button>
          <button onClick={() => this.removeAgency(agency)}>
            <span><MdDelete size={20} color='#8492a6' /></span>
          </button>
        </td>
      )
    }

    renderDeleteForm (toDelete) {
      const name = (toDelete.firstName==null? '': toDelete.firstName + ' ' ) + (toDelete.lastName==null? '' : toDelete.lastName) //getFullName(toDelete.member);
      
      return (
        <div className="alert-modal">
          <h1>Confirm</h1>
          <p>{ `Are you sure you want to remove ${name} from this list?` }</p>
          <button className="alert-cancel" onClick={this.deleteHandler}>Yes, Delete!</button>
          <div className="modal-close" onClick={this.closeModal}>
            <span className="close"></span>
          </div>
        </div>
      )
    }

    renderTable(clientAgencies) {
        const { roleModules } = this.props.permissions.editPrivileges;
        const canEdit = roleModules !== null && roleModules.includes('Client Agency') 
        ? true : false;

        return (
            <div className="table-wrap">
                <table>
                    <thead>
                        <tr>
                            <th>Sponsor Agency Name</th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Title</th>
                            <th>Work Phone</th>
                            <th>Mobile Phone</th>
                            <th>Email</th>
                            { canEdit && <th>Actions</th> }
                        </tr>
                    </thead>
                    <tbody>
                         {clientAgencies.map(agency =>
                    <tr key={agency.id}>
                      <td>{agency.agencyName}</td>
                      <td>{agency.firstName}</td>
                      <td>{agency.lastName}</td>
                      <td>{agency.lkp_ClientAgencyTitles.title}</td>
                      <td>{agency.workPhone}</td>
                      <td>{agency.mobilePhone}</td>
                      <td>{agency.email}</td>
                       { canEdit && this.renderRowButtons(agency) } 
                    </tr>
                  )} 
                    </tbody>
                </table>
            </div>
        );
    }

    renderEditForm(toEdit) {
        let heading = '';

        if (toEdit.id)
            heading = 'Edit Sponsor Agency Info';
        else
            heading = 'Add Sponsor Agency Info';

        return (
            <div>
                <h1>{heading}</h1>

                 <ClientAgencyInfoForm
                    clientAgency={toEdit}
                    projectId={this.props.projectId}
                    onSave={this.saveHandler}
              /> 

                <div className="modal-close" onClick={this.onDone}>
                    <span className="close"></span>
                </div>
            </div>
        );
    }

    renderModal() {
        const { toEdit, toDelete } = this.state;
        // const isOpen = !(toEdit === null);
        let Content = null;
        if (toEdit) Content = this.renderEditForm(toEdit);
        else if (toDelete) Content = this.renderDeleteForm(toDelete);
    
        if (window.innerWidth < 768) {
            return (
              <Modal
                // isOpen={isOpen}
                isOpen={!!Content}
                style={mediumModalStyle}
                contentLabel="Sponsor Agency Info Form"
              >
                {Content}
              </Modal>
            );
          }
          else {
            return (
                <Modal
                    // isOpen={isOpen}
                    isOpen={!!Content}
                    style={modalStyle}
                    contentLabel="Sponsor Agency Info Form"
                >
                    {Content}
                </Modal>
            );
          }
    }

    render() {
        const { clientAgencies } = this.props;
        const { roleModules } = this.props.permissions.editPrivileges;
        const canEdit = roleModules !== null && roleModules.includes('Client Agency') 
        ? true : false;

        return (
            <div id="clientAgency" className="row-wide project-logs">
                <div className="col s12">
                    <h4 className="bar-bottom">
                        <span><MdAccountBalance size={20} /></span>  Sponsor Agency Info
              </h4>
                </div>

                {this.renderModal()}

                <div className="col s12">
                     {clientAgencies.length 
                     ? this.renderTable(clientAgencies)
                     : <div>This project has no Sponsor agencies yet.</div>} 
                </div>

                {canEdit &&
                    <div className="section-buttons">
                        <button className="btn-save" onClick={() => this.startAdd({})}>
                            Add
                    </button>
                    </div>}

            </div>
        );
    }
}

ClientAgencyInfo.propTypes = {
  permissions: PropTypes.object.isRequired,
  projectId: PropTypes.string.isRequired,
  clientAgencies: PropTypes.array.isRequired,
  fetchClientAgencies: PropTypes.func.isRequired
};

function mapStateToProps(state, ownProps) {
    return {
      projectId: ownProps.projectId,
      clientAgencies: state.additionalProjectsStore.clientAgencies,
    };
}

export default connect(mapStateToProps, { fetchClientAgencies })(ClientAgencyInfo);